export default __webpack_public_path__ + "static/10-2d285268255b47d8adf7df6e71234d78.jpg";